// javascript
// `crm/src/mixins/heightFadeTransition.js`
export default {
  methods: {
    beforeEnter(el) {
      el.style.opacity = '0';
      el.style.height = '0px';
      el.style.overflow = 'hidden';
      el.style.transition =
        'height 260ms cubic-bezier(.2,.8,.2,1), opacity 260ms cubic-bezier(.2,.8,.2,1)';
    },
    enter(el, done) {
      const targetHeight = el.scrollHeight + 'px';
      requestAnimationFrame(() => {
        el.style.height = targetHeight;
        el.style.opacity = '1';
      });
      const onEnd = (e) => {
        if (e && e.target !== el) return;
        el.removeEventListener('transitionend', onEnd);
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
        done && done();
      };
      el.addEventListener('transitionend', onEnd);
    },
    afterEnter(el) {
      el.style.height = '';
      el.style.opacity = '';
      el.style.overflow = '';
      el.style.transition = '';
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
      el.style.opacity = '1';
      el.style.overflow = 'hidden';
      el.style.transition =
        'height 260ms cubic-bezier(.2,.8,.2,1), opacity 260ms cubic-bezier(.2,.8,.2,1)';
      void el.offsetHeight;
    },
    leave(el, done) {
      requestAnimationFrame(() => {
        el.style.height = '0px';
        el.style.opacity = '0';
      });
      const onEnd = (e) => {
        if (e && e.target !== el) return;
        el.removeEventListener('transitionend', onEnd);
        done && done();
      };
      el.addEventListener('transitionend', onEnd);
    },
    afterLeave(el) {
      el.style.height = '';
      el.style.opacity = '';
      el.style.overflow = '';
      el.style.transition = '';
    }
  }
};
